import { Component } from '@angular/core';
import {LogMessage} from '../../models/error/LogMessage';
import {LogMessageService} from '../../services/error/log-message.service';
import {BaseErrorDetailRecordComponent} from '../common/base-error-detail-record/base-error-detail-record.component';
import {ErrorDetailRuleComponent} from '../common/error-detail-rule/error-detail-rule.component';
import {
    ErrorDetailTableRecordTemplateComponent
} from '../common/error-detail-table-record-template/error-detail-table-record-template.component';

@Component({
    selector: 'app-log-detail-record',
    templateUrl: './log-detail-record.component.html',
    styleUrls: ['./log-detail-record.component.css'],
    standalone: true,
    imports: [
        ErrorDetailRuleComponent,
        ErrorDetailTableRecordTemplateComponent
    ]
})
export class LogDetailRecordComponent extends BaseErrorDetailRecordComponent<LogMessage> {
    constructor(private logService: LogMessageService) {
        super(logService);
    }
}
